//PaymentMethod

export enum CreditCardBrandEnum {
  VISA = 'VISA',
  MASTERCARD = 'MASTERCARD',
  AMERICAN_EXPRESS = 'AMERICAN_EXPRESS',
  SOROCRED = 'SOROCRED',
  DINERS_CLUB = 'DINERS_CLUB',
  ELO = 'ELO',
  HIPERCARD = 'HIPERCARD',
  AURA = 'AURA',
  CABAL = 'CABAL',
  ALELO = 'ALELO',
  BANES_CARD = 'BANES_CARD',
  CALCARD = 'CALCARD',
  CREDZ = 'CREDZ',
  DISCOVER = 'DISCOVER',
  GOODCARD = 'GOODCARD',
  GREENCARD = 'GREENCARD',
  HIPER = 'HIPER',
  JCB = 'JCB',
  MAIS = 'MAIS',
  MAXVAN = 'MAXVAN',
  POLICARD = 'POLICARD',
  REDECOMPRAS = 'REDECOMPRAS',
  SODEXO = 'SODEXO',
  VALECARD = 'VALECARD',
  VEROCHEQUE = 'VEROCHEQUE',
  VR = 'VR',
  TICKET = 'TICKET',
  OTHERS = 'OTHERS',
}

export const creditCardBrandOptions = [
  { value: CreditCardBrandEnum.VISA, label: 'Visa' },
  { value: CreditCardBrandEnum.MASTERCARD, label: 'Mastercard' },
  { value: CreditCardBrandEnum.AMERICAN_EXPRESS, label: 'American express' },
  { value: CreditCardBrandEnum.SOROCRED, label: 'Sorocred' },
  { value: CreditCardBrandEnum.DINERS_CLUB, label: 'Diners club' },
  { value: CreditCardBrandEnum.ELO, label: 'Elo' },
  { value: CreditCardBrandEnum.HIPERCARD, label: 'Hipercard' },
  { value: CreditCardBrandEnum.AURA, label: 'Aura' },
  { value: CreditCardBrandEnum.CABAL, label: 'Cabal' },
  { value: CreditCardBrandEnum.ALELO, label: 'Alelo' },
  { value: CreditCardBrandEnum.BANES_CARD, label: 'Banes Card' },
  { value: CreditCardBrandEnum.CALCARD, label: 'Calcard' },
  { value: CreditCardBrandEnum.CREDZ, label: 'Credz' },
  { value: CreditCardBrandEnum.DISCOVER, label: 'Discover' },
  { value: CreditCardBrandEnum.GOODCARD, label: 'Good Card' },
  { value: CreditCardBrandEnum.GREENCARD, label: 'Green Card' },
  { value: CreditCardBrandEnum.HIPER, label: 'Hiper' },
  { value: CreditCardBrandEnum.JCB, label: 'JCB' },
  { value: CreditCardBrandEnum.MAIS, label: 'Mais' },
  { value: CreditCardBrandEnum.MAXVAN, label: 'Maxvan' },
  { value: CreditCardBrandEnum.POLICARD, label: 'Policard' },
  { value: CreditCardBrandEnum.REDECOMPRAS, label: 'Redecompras' },
  { value: CreditCardBrandEnum.SODEXO, label: 'Sodexo' },
  { value: CreditCardBrandEnum.VALECARD, label: 'Valecard' },
  { value: CreditCardBrandEnum.VEROCHEQUE, label: 'Verocheque' },
  { value: CreditCardBrandEnum.VR, label: 'VR' },
  { value: CreditCardBrandEnum.TICKET, label: 'Ticket' },
  { value: CreditCardBrandEnum.OTHERS, label: 'Outros' },
];

export enum PaymentMethodEnum {
  CASH = 'CASH',
  CHEQUE = 'CHEQUE',
  CREDIT_CARD = 'CREDIT_CARD',
  DEBIT_CARD = 'DEBIT_CARD',
  STORE_CREDIT = 'STORE_CREDIT',
  STORE_CARD = 'STORE_CARD',
  FOOD_VOUCHER = 'FOOD_VOUCHER',
  MEAL_VOUCHER = 'MEAL_VOUCHER',
  GIFT_VOUCHER = 'GIFT_VOUCHER',
  FUEL_VOUCHER = 'FUEL_VOUCHER',
  BANK_SLIP = 'BANK_SLIP',
  BANK_DEPOSIT = 'BANK_DEPOSIT',
  INSTANT_PAYMENT = 'INSTANT_PAYMENT',
  BANK_TRANSFER = 'BANK_TRANSFER',
  LOYALTY_PROGRAM = 'LOYALTY_PROGRAM',
  NO_PAYMENT = 'NO_PAYMENT',
  INSTANT_PAYMENT_STATIC = 'INSTANT_PAYMENT_STATIC',
  UNKNOWN_ELECTRONIC = 'UNKNOWN_ELECTRONIC',
  PAYMENT_LATER = 'PAYMENT_LATER',
  OTHERS = 'OTHERS',
}

export const PaymentMethodTranslate = {
  [PaymentMethodEnum.CASH]: 'Dinheiro',
  [PaymentMethodEnum.CHEQUE]: 'Cheque',
  [PaymentMethodEnum.CREDIT_CARD]: 'Cartão de crédito',
  [PaymentMethodEnum.DEBIT_CARD]: 'Cartão de débito',
  [PaymentMethodEnum.STORE_CREDIT]: 'Crédito da loja',
  [PaymentMethodEnum.STORE_CARD]: 'Cartão da loja',
  [PaymentMethodEnum.FOOD_VOUCHER]: 'Vale alimentação',
  [PaymentMethodEnum.MEAL_VOUCHER]: 'Vale refeição',
  [PaymentMethodEnum.GIFT_VOUCHER]: 'Vale presente',
  [PaymentMethodEnum.FUEL_VOUCHER]: 'Vale combustível',
  [PaymentMethodEnum.BANK_SLIP]: 'Boleto bancário ',
  [PaymentMethodEnum.BANK_DEPOSIT]: 'Depósito bancário',
  [PaymentMethodEnum.INSTANT_PAYMENT]: 'Pagamento instantâneo (PIX)',
  [PaymentMethodEnum.BANK_TRANSFER]: 'Transferência bancária',
  [PaymentMethodEnum.LOYALTY_PROGRAM]: 'Programa de fidelidade',
  [PaymentMethodEnum.NO_PAYMENT]: 'Sem pagamento',
  [PaymentMethodEnum.INSTANT_PAYMENT_STATIC]: 'Pagamento Instantâneo Estático',
  [PaymentMethodEnum.UNKNOWN_ELECTRONIC]: 'Pagamento Eletrônico não Informado',
  [PaymentMethodEnum.PAYMENT_LATER]: 'Pagamento Posterior',
  [PaymentMethodEnum.OTHERS]: 'Outros',
};

export interface PaymentMethodCreateRequestDTO {
  authorizationNumber?: string;
  cnpj?: string;
  creditCardBrand?: CreditCardBrandEnum;
  descriptionPaymentMethod?: string;
  intagrationType?: number;
  paymentMethod: PaymentMethodEnum;
  value: number;
  id: number;
  invoiceId: number;
}
